module.exports = {
  mock: {
    baseURL: '/dev-api',
    mockURL: 'https://mock.xwhx.top'
  },
  local: {
    baseURL: '/dev-api',
    mockURL: 'http://0.0.0.0:7001'
  },
  development: {
    // baseURL: 'http://47.57.156.216/',
    mockURL: 'http://47.57.156.216/'
  },
  production: {
    baseURL: '',
    mockURL: ''
  }
}
